import React from 'react'
import { Button, styled } from '@mui/material'

const TextBotton = styled('div')(() => ({
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '12px',
  textAlign: 'center',
}))

const BottomCustom = ({
  text,
  styleText,
  styleButton,
  variant = 'outlined',
  size = 'medium',
  ...otherProps
}) => {
  const propsDefault = { variant, size }
  return (
    <Button {...propsDefault} {...otherProps} sx={{ ...styleButton }}>
      <TextBotton sx={styleText}>{text}</TextBotton>
    </Button>
  )
}

export default BottomCustom
